import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import {
  boundariesSet,
  concatenateBoundariesByname
} from '../../../utilities/helpers';
import { organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import { dateOptionsCriteria } from '../../../utilities/epic-helpers';

import saveAs from 'file-saver';

import {
  DOWNLOAD_TRAVEL_PAST_INSIGHTS,
  DOWNLOAD_TRAVEL_PAST_INSIGHTS_SUCCESS,
  DOWNLOAD_TRAVEL_PAST_INSIGHTS_FAILURE,
} from '../../constants';
import moment from 'moment';


const downloadTravelPast = (action$, state$) =>
  action$.pipe(
    ofType(DOWNLOAD_TRAVEL_PAST_INSIGHTS),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/report/travel-past/${action.csvType}/download?${
          action.csvType === 'reach-and-frequency' ?
            `&since=${encodeURIComponent(moment("20190501", "YYYYMMDD").startOf('day').format())}&until=${encodeURIComponent(moment("20190601", "YYYYMMDD").endOf('day').format())}` :
            dateOptionsCriteria(state$, 'travelPast')
          }${
          organisationTabCriteria(state$)
          }${
          boundariesCriteria(state$)
          }${
          state$.value.travelPast.averageFilter
            ? `&average_filter=${encodeURIComponent(
              state$.value.travelPast.averageFilter
            )}`
            : ''
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'text',
        crossDomain: true,
      }).pipe(
        map(response => {


          const blob = new Blob(
            [
              `${response.response}`,
            ],
            { type: 'text/csv' }
          );

          const fileName = `LANDMARKSID_${action.reportType}_${action.fileName}${
            state$.value.insightsCriteria.insightType === 'organisation' &&
              state$.value.insightsCriteria.organisation.label
              ? `_${state$.value.insightsCriteria.organisation.label}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm0) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm0
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm1) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm1
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm2) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm2
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm3) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm3
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm4) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm4
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.poiId) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.poiId
              )}`
              : ''
            }_${state$.value.travelPast.selectedPeriod.label}.csv`;

          saveAs(blob, fileName);
          return {
            type: DOWNLOAD_TRAVEL_PAST_INSIGHTS_SUCCESS,
          };
        }),
        catchError(error =>
          of({
            type: DOWNLOAD_TRAVEL_PAST_INSIGHTS_FAILURE,
            error,
          })
        )
      )
    )
  );

export default downloadTravelPast;
